module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-35.a7af94ba.png";